import { useEffect, useState } from "react";
import CrudResource from "@/components/CrudResource";
import { fmtDate } from "@/lib/api";
import api from "@/lib/api";
import { Loading } from "@/components/common";

export default function Staff() {
  const [branches, setBranches] = useState(null);
  useEffect(() => { api.get("/branches").then(({ data }) => setBranches(data)).catch(() => setBranches([])); }, []);
  if (branches === null) return <Loading />;

  const branchOpts = branches.map((b) => ({ value: b.id, label: b.name }));
  const branchName = (id) => branches.find((b) => b.id === id)?.name || "-";

  return (
    <CrudResource
      title="Data Karyawan"
      subtitle="Kelola akun, cabang, role & gaji pokok karyawan"
      endpoint="/staff"
      searchable={false}
      columns={[
        { key: "name", label: "Nama" },
        { key: "email", label: "Email" },
        { key: "role", label: "Role", render: (r) => <span className="capitalize">{r.role}</span> },
        { key: "branch_id", label: "Cabang", render: (r) => branchName(r.branch_id) },
        { key: "base_salary", label: "Gaji Pokok", money: true },
        { key: "created_at", label: "Dibuat", render: (r) => fmtDate(r.created_at) },
      ]}
      fields={[
        { name: "name", label: "Nama", required: true, full: true },
        { name: "email", label: "Email", required: true },
        { name: "password", label: "Password", required: true },
        { name: "role", label: "Role", type: "select", default: "kasir",
          options: [{ value: "owner", label: "Owner" }, { value: "staff", label: "Staff (akses penuh)" }, { value: "kasir", label: "Kasir (terbatas)" }] },
        { name: "branch_id", label: "Cabang", type: "select", options: branchOpts },
        { name: "base_salary", label: "Gaji Pokok", type: "number" },
        { name: "phone", label: "Telepon" },
      ]}
    />
  );
}
